// features/auth/Welcome.js
import { useState, useRef, useEffect } from 'react'
import useTitle from '../../hooks/useTitle'
import useAuth from '../../hooks/useAuth'
import districtsData from '../districts-tphcm.json'
import { useAddNewPropertyMutation, useCheckPhoneExistsQuery } from '../properties/PropertiesApiSlice'
import PropertiesList from '../properties/PropertiesList'
import Select from "react-select";
import PhoneTagInput from "../utils/PhoneTagInput"
import { Modal } from 'react-bootstrap'
import uploadToCloudinary from '../utils/cloudinaryUpload';

const Welcome = () => {
    useTitle('Nhà đẹp - Quản lý bất động sản')
    const { username, isAdmin, userId } = useAuth()  
    const [isFilterOpen, setIsFilterOpen] = useState(false)
    const [showAddModal, setShowAddModal] = useState(false)
    const [addNewProperty, { isSuccess, isError, error }] = useAddNewPropertyMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    // Các state lọc
    const [currentPage, setCurrentPage] = useState(1)
    const [quickSearch, setQuickSearch] = useState('')
    const [debouncedSearch, setDebouncedSearch] = useState('')
    const [phoneSearch, setPhoneSearch] = useState('')
    const [district, setDistrict] = useState([])
    const [propertyType, setPropertyType] = useState([])
    const [newWard, setNewWard] = useState([])
    const [position, setPosition] = useState([])
    const [dateFilterType, setDateFilterType] = useState('updated')
    
    // Các trường số với operator và giá trị (hỗ trợ khoảng)
    const initialNumberFields = [
        { key: 'width', label: 'Bề ngang (m)', operator: 'eq', value1: '', value2: '' },
        { key: 'length', label: 'Chiều dài (m)', operator: 'eq', value1: '', value2: '' },
        { key: 'floorArea', label: 'Diện tích sàn (m²)', operator: 'eq', value1: '', value2: '' },
        { key: 'totalArea', label: 'Tổng diện tích sàn (m²)', operator: 'eq', value1: '', value2: '' },
        { key: 'price', label: 'Giá thuê (VNĐ)', operator: 'eq', value1: '', value2: '' },
        { key: 'floors', label: 'Số tầng', operator: 'eq', value1: '', value2: '' },
    ]
    const [numbers, setNumbers] = useState(initialNumberFields)

    useEffect(() => {
        setCurrentPage(1)
    }, [
        debouncedSearch,     // quick search
        phoneSearch,
        district,
        propertyType,
        newWard,
        position,
        numbers,             // khoảng giá
        dateFilterType       // createdAt / updatedAt
    ])

    const [phoneToCheck, setPhoneToCheck] = useState('')
    const hiddenPasteInput = useRef(null)
    const fileInputMobileRef = useRef(null)
    // ===== Tất cả phường mới từ districts-tphcm.json (unique + sort A→Z) =====
    const allNewWards = Array.from(
        new Set(
            Object.values(districtsData).flatMap(d => d.new || [])
        )
    ).sort((a, b) => a.localeCompare(b, 'vi'))

    const newWardOptions = allNewWards.map(ward => ({
        value: ward,
        label: ward
    }))
    // ===== Options Vị trí =====
    const positionOptions = [
        "Mặt tiền",
        "Mặt tiền hẻm",
        "2 mặt tiền",
        "3 mặt tiền"
    ].map(p => ({ value: p, label: p }))

    // Modal xác nhận thoát
    const [showConfirmExit, setShowConfirmExit] = useState(false)
    
    // Modal cảnh báo SĐT đã tồn tại
    const [showPhoneExistsModal, setShowPhoneExistsModal] = useState(false)

    // Form thêm mới
    const [formData, setFormData] = useState({
        phone: [],
        ownerName: '',
        ownerType: 'Chủ nhà',
        houseNumber: '',
        street: '',
        oldDistrict: '',
        oldWard: '',
        newWard: '',
        propertyType: 'Nhà phố',
        width: '',
        length: '',
        floorArea: '',
        totalArea: '',
        floors: '',
        price: '',
        position: 'Mặt tiền',
        description: '',
        status: 'Đang cho thuê',
        images: [],           // sẽ là mảng File ban đầu
        imageUrls: [],        // ← mới: mảng URL từ Cloudinary (sau khi upload xong)
        createdBy: username,  // ← tự động điền
        updatedBy: username
    })
    
    const { data: isPhoneExisted = false, isFetching: checkingPhone } = useCheckPhoneExistsQuery(
        phoneToCheck ? { phone: phoneToCheck, excludeId: formData.id } : null,
        {
            skip: !phoneToCheck || phoneToCheck.length < 9
        }
    )
    useEffect(() => {
        if (!phoneToCheck) return
        if (checkingPhone) return // đang check

        if (isPhoneExisted) {
            setShowPhoneExistsModal(true)
            //setPhoneToCheck('')
        }
    }, [isPhoneExisted, checkingPhone, phoneToCheck])

    const selectedOldWards = formData.oldDistrict ? districtsData[formData.oldDistrict]?.old || [] : []
    const selectedNewWards = formData.oldDistrict ? districtsData[formData.oldDistrict]?.new || [] : []
    const fileInputRef = useRef(null)

    useEffect(() => {
        setCurrentPage(1)
    }, [dateFilterType])

    const proceedToSubmit = async () => {
        // let imageUrls = []
        // if (formData.images.length > 0) {
        //     imageUrls = await uploadToCloudinary(formData.images)
        //     if (!imageUrls) {
        //         alert('Lỗi upload ảnh')
        //         return
        //     }
        // }

        const imageObjects = await uploadToCloudinary(formData.images);  // trả về [{ public_id }, ...]
        try {
            await addNewProperty({
                user: userId,
                phone: formData.phone,
                ownerName: formData.ownerName.trim(),
                ownerType: formData.ownerType,
                houseNumber: formData.houseNumber?.trim() || '',
                street: formData.street.trim(),
                oldDistrict: formData.oldDistrict,
                oldWard: formData.oldWard || '',
                newWard: formData.newWard || '',
                propertyType: formData.propertyType,
                width: formData.width ? Number(formData.width) : null,
                length: formData.length ? Number(formData.length) : null,
                floorArea: formData.floorArea ? Number(formData.floorArea) : null,
                totalArea: formData.totalArea ? Number(formData.totalArea) : null,
                floors: formData.floors ? Number(formData.floors) : null,
                price: formData.price ? Number(formData.price) : null,
                position: formData.position,
                description: formData.description?.trim() || '',
                status: formData.status,
                images: imageObjects,
                // images: imageUrls,
                createdBy: username
            }).unwrap()

            // setTimeout(() => {
            setShowAddModal(false)
            resetForm()
            // }, 2000)
        } catch (err) {
            console.error('Lỗi thêm BĐS:', err)
            alert(err.data?.message || 'Không thể thêm bất động sản')
        }
    }    

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value,
            ...(name === 'oldDistrict' && { oldWard: '', newWard: '' })
        }))
    }

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files)
        setFormData(prev => ({ ...prev, images: [...prev.images, ...files] }))
    }

    const removeImage = (index) => {
        setFormData(prev => ({
            ...prev,
            images: prev.images.filter((_, i) => i !== index)
        }))
    }

    const resetForm = () => {
        setFormData({
            phone: [], ownerName: '', ownerType: 'Chủ nhà', houseNumber: '', street: '',
            oldDistrict: '', oldWard: '', newWard: '', propertyType: 'Nhà phố',
            width: '', length: '', floorArea: '', totalArea: '', floors: '', price: '',
            position: 'Mặt tiền', description: '', status: 'Đang cho thuê',
            images: [], imageUrls: [], createdBy: username  // ← giữ lại
        })
        setShowPhoneExistsModal(false)
    }

    // const uploadToCloudinary = async (files) => {
    //     if (!files || files.length === 0) return []

    //     const uploadedImages = [] // ← mảng object { url, public_id }
    //     const uploadPreset = 'realestate-upload'
    //     const cloudName = 'dp9lxlric'

    //     for (const file of files) {
    //         const formData = new FormData()
    //         formData.append('file', file)
    //         formData.append('upload_preset', uploadPreset)
    //         formData.append('folder', 'properties') // giữ nguyên thư mục

    //         try {
    //             const res = await fetch(
    //                 `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
    //                 {
    //                     method: 'POST',
    //                     body: formData
    //                 }
    //             )

    //             const data = await res.json()

    //             if (data.secure_url && data.public_id) {
    //                 uploadedImages.push({
    //                     url: data.secure_url,
    //                     public_id: data.public_id  // ← QUAN TRỌNG: dùng để xóa sau này
    //                 })
    //             } else {
    //                 console.error('Upload thất bại, không có secure_url:', data)
    //                 // Không return null → vẫn tiếp tục upload các ảnh khác
    //             }
    //         } catch (err) {
    //             console.error('Lỗi mạng khi upload ảnh:', err)
    //             // Không break → vẫn cố upload ảnh còn lại
    //         }
    //     }

    //     return uploadedImages // ← Trả về: [{ url: "...", public_id: "properties/abc123" }, ...]
    // }

    const handleSubmit = async () => {
        if (!formData.phone.length || !formData.street || !formData.oldDistrict) {
            alert('Vui lòng điền đầy đủ các trường có dấu (*)')
            return
        }
        setIsSubmitting(true)
        try {
            await proceedToSubmit()
        } catch (err) {
            // lỗi đã được xử lý trong proceedToSubmit
        } finally {
            setIsSubmitting(false)
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(quickSearch);
            setCurrentPage(1);
        }, 500);

        return () => clearTimeout(timer);
    }, [quickSearch]);

    useEffect(() => {
        const handler = (e) => {
            const phone = e.detail
            if (phone) {
                setPhoneSearch(phone)
                setQuickSearch('')
                setCurrentPage(1)
            }
        }

        window.addEventListener('searchByPhone', handler)
        return () => window.removeEventListener('searchByPhone', handler)
    }, [])

    const handlePhoneExistAction = (action) => {
        setShowPhoneExistsModal(false)
        if (action === 'view') {
            setPhoneSearch(phoneToCheck)
            setQuickSearch('')           // xóa quickSearch nếu có
            setCurrentPage(1)            // về trang 1
            setShowAddModal(false)     
            resetForm()
        }
        setPhoneToCheck('')
    }

    const handleForceSubmit = () => {
        setShowPhoneExistsModal(false)
        setPhoneToCheck('')
    }

    const handleNumberChange = (key, field, value) => {
        setNumbers(prev => prev.map(item =>
            item.key === key ? { ...item, [field]: value } : item
        ))
    }

    const handleQuickSearch = () => {
        setCurrentPage(1)
        setIsFilterOpen(false)
    }

    // Chỉ cho nhập số
    const handlePhoneInput = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, '')
        setPhoneSearch(value)
    }

    const handlePasteImage = async (e) => {
        const items = e.clipboardData?.items;

        if (!items || items.length === 0) return;

        for (const item of items) {
            if (item.type.startsWith("image/")) {
                const blob = item.getAsFile();
                if (!blob) return;

                // Đổi tên file cho dễ quản lý
                const file = new File([blob], `pasted-${Date.now()}.png`, { type: "image/png" });

                // Thêm vào formData.images (giống như chọn file thủ công)
                setFormData(prev => ({
                    ...prev,
                    images: [...prev.images, file]
                }));
            }
        }
    };

    const handleSmartPaste = async () => {
        try {
            // 1. Thử đọc clipboard (chỉ hoạt động trên HTTPS hoặc localhost)
            const clipboardItems = await navigator.clipboard.read()
            let hasImage = false

            for (const item of clipboardItems) {
                for (const type of item.types) {
                    if (type.startsWith('image/')) {
                        hasImage = true
                        const blob = await item.getType(type)
                        const file = new File([blob], `pasted-${Date.now()}.png`, { type: blob.type })
                        
                        setFormData(prev => ({
                            ...prev,
                            images: [...prev.images, file]
                        }))
                        return
                    }
                }
            }

            // 2. Nếu không có ảnh trong clipboard → mở thư viện
            if (!hasImage) {
                fileInputMobileRef.current?.click()
            }

        } catch (err) {
            // 3. Nếu trình duyệt chặn clipboard (rất hay xảy ra trên mobile)
            console.log('Clipboard API bị chặn, chuyển sang cách thủ công')
            hiddenPasteInput.current?.focus()
        }
    }

    // ===== Options Quận/huyện =====
    const districtOptions = [
        "Quận 1", "Quận 2", "Quận 3", "Quận 4", "Quận 5", "Quận 6",
        "Quận 7", "Quận 8", "Quận 9", "Quận 10", "Quận 11", "Quận 12",
        "Quận Bình Tân", "Quận Bình Thạnh", "Quận Gò Vấp", "Quận Phú Nhuận",
        "Quận Tân Bình", "Quận Tân Phú", "Quận Thủ Đức",
        "Huyện Bình Chánh", "Huyện Hóc Môn", "Huyện Củ Chi",
        "Huyện Cần Giờ", "Huyện Nhà Bè",
    ].map(d => ({ value: d, label: d }))

    // ===== Options Loại nhà =====
    const propertyTypeOptions = [
        "Nhà phố",
        "Biệt thự",
        "Toà nhà văn phòng",
        "Đất trống",
        "Kho xưởng",
    ].map(t => ({ value: t, label: t }))

    return (
        <div className="container position-relative">
            {/* Tìm kiếm nhanh + Nút mở filter */}
            <div className="card bg-dark border-secondary border-opacity-25 shadow mb-4" style={{ borderRadius: '1rem' }}>
                <div className="card-body p-4">
                    <div className="row g-3 align-items-center">
                        <div className="col-12 col-lg-8">
                            <input
                                type="text"
                                className="form-control form-control-lg border-0 text-dark"
                                placeholder="Nhập tên đường để tìm nhanh..."
                                value={quickSearch}
                                onChange={(e) => setQuickSearch(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && handleQuickSearch()}
                                style={{ borderRadius: '0.75rem' }}
                            />
                        </div>
                        <div className="col-6 col-lg-2">
                            <button
                                type="button"
                                className="btn btn-outline-info btn-lg w-100 rounded-pill"
                                onClick={() => setIsFilterOpen(!isFilterOpen)}
                            >
                                Bộ lọc{' '}
                                <i className={`bi ${isFilterOpen ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                            </button>
                        </div>
                        <div className="col-6 col-lg-2">
                            <button
                                type="button"
                                onClick={() => {
                                    //setDebouncedSearch('');
                                    setQuickSearch('')
                                    setPhoneSearch('')
                                    setDistrict([])
                                    setPropertyType([])
                                    setNewWard([])
                                    setPosition([])
                                    setNumbers(initialNumberFields)  // reset các bộ lọc số
                                    setDateFilterType('updated')
                                    setCurrentPage(1)
                                    setIsFilterOpen(false)  // đóng luôn bộ lọc cho sạch
                                }}
                                className="btn btn-primary btn-lg w-100 rounded-pill shadow-sm"
                                title="Làm mới toàn bộ tìm kiếm"
                            >
                                <i className="bi bi-arrow-clockwise"></i>Làm mới
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bộ lọc nâng cao */}
            {isFilterOpen && (
                <div className="card bg-dark border-info border-opacity-50 shadow-lg mb-4 animate__animated animate__fadeIn" style={{ borderRadius: '1rem' }}>
                    <div className="card-body p-4">
                        <h5 className="text-info mb-4">
                            <i className="bi bi-funnel-fill me-2"></i>Bộ lọc chi tiết
                        </h5>

                        {/* Chỉ Admin thấy */}
                        {isAdmin && (
                            <div className="row g-3 mb-4">
                                <div className="col-12 col-md-6">
                                    <input
                                        type="text"
                                        className="form-control border-0 text-black"
                                        placeholder="Số điện thoại khách hàng (chỉ nhập số)"
                                        value={phoneSearch}
                                        onChange={handlePhoneInput}
                                        maxLength="11"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="btn-group w-100" role="group">
                                        <input type="radio" className="btn-check" name="dateType" id="created"
                                               checked={dateFilterType === 'created'}
                                               onChange={() => setDateFilterType('created')} />
                                        <label className="btn btn-outline-warning" htmlFor="created">Ngày nhập</label>

                                        <input type="radio" className="btn-check" name="dateType" id="updated"
                                               checked={dateFilterType === 'updated'}
                                               onChange={() => setDateFilterType('updated')} />
                                        <label className="btn btn-outline-warning" htmlFor="updated">Ngày cập nhật</label>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Quận/huyện cũ & Loại nhà */}
                        <div className="row g-3 mb-3">
                            <div className="col-12 col-md-6">
                                <label className="text-white mb-2">Chọn Quận/huyện (cũ)</label>
                                <Select
                                    isMulti
                                    options={districtOptions}
                                    placeholder="Chọn Quận/huyện..."
                                    value={districtOptions.filter(opt => district.includes(opt.value))}
                                    onChange={(selected) => setDistrict(selected.map(s => s.value))}
                                    className="text-dark"
                                    classNamePrefix="react-select"
                                    styles={{
                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                />
                            </div>

                            <div className="col-12 col-md-6">
                                <label className="text-white mb-2">Loại nhà</label>
                                <Select
                                    isMulti
                                    options={propertyTypeOptions}
                                    placeholder="Chọn loại nhà..."
                                    value={propertyTypeOptions.filter(opt => propertyType.includes(opt.value))}
                                    onChange={(selected) => setPropertyType(selected.map(s => s.value))}
                                    className="text-dark"
                                    classNamePrefix="react-select"
                                    styles={{
                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                />
                            </div>
                        </div>

                        {/* Phường mới & Vị trí */}
                        <div className="row g-3 mb-3">
                            <div className="col-12 col-md-6">
                                <label className="text-white mb-2">Phường mới</label>
                                <Select
                                    isMulti
                                    options={newWardOptions}
                                    placeholder="Chọn phường mới..."
                                    value={newWardOptions.filter(opt => newWard.includes(opt.value))}
                                    onChange={(selected) => setNewWard(selected.map(s => s.value))}
                                    className="text-dark"
                                    classNamePrefix="react-select"
                                    styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>

                            <div className="col-12 col-md-6">
                                <label className="text-white mb-2">Vị trí</label>
                                <Select
                                    isMulti
                                    options={positionOptions}
                                    placeholder="Chọn vị trí..."
                                    value={positionOptions.filter(opt => position.includes(opt.value))}
                                    onChange={(selected) => setPosition(selected.map(s => s.value))}
                                    className="text-dark"
                                    classNamePrefix="react-select"
                                    styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>

                        {/* Các trường số - hỗ trợ "Trong khoảng" */}
                        <div className="row g-3">
                            {numbers.map((field) => (
                                <div key={field.key} className="col-12 col-md-6 col-lg-4">
                                    <label className="text-white small d-block mb-1">{field.label}</label>
                                    <div className="input-group mb-2">
                                        <select
                                            className="form-select"
                                            style={{ maxWidth: '140px' }}
                                            value={field.operator}
                                            onChange={(e) => handleNumberChange(field.key, 'operator', e.target.value)}
                                        >
                                            <option value="eq">Bằng</option>
                                            <option value="lt">&lt;</option>
                                            <option value="lte">≤</option>
                                            <option value="gt">&gt;</option>
                                            <option value="gte">≥</option>
                                            <option value="range">Khoảng</option>
                                        </select>
                                        <input
                                            type="number"
                                            className="form-control border-0 text-black"
                                            placeholder="Giá trị"
                                            value={field.value1}
                                            onChange={(e) => handleNumberChange(field.key, 'value1', e.target.value)}
                                        />
                                    </div>
                                    {/* Ô thứ 2 chỉ hiện khi chọn "Trong khoảng" */}
                                    {field.operator === 'range' && (
                                        <input
                                            type="number"
                                            className="form-control border-0 text-black mt-2"
                                            placeholder="Đến giá trị"
                                            value={field.value2}
                                            onChange={(e) => handleNumberChange(field.key, 'value2', e.target.value)}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Danh sách bất động sản */}
            <PropertiesList
                page={currentPage}
                setPage={setCurrentPage}
                quickSearch={debouncedSearch}
                phoneSearch={phoneSearch}
                district={district}
                propertyType={propertyType}
                newWard={newWard}
                position={position}
                numbers={numbers.filter(n => n.operator && (n.value1 || n.value2))}
                dateType={dateFilterType === 'created' ? 'createdAt' : 'updatedAt'}
                key={debouncedSearch}
            />

            {/* Nút thêm mới */}
            <button
                className="btn btn-primary btn-lg rounded-circle shadow-lg position-fixed d-flex align-items-center justify-content-center"
                style={{ bottom: '30px', right: '30px', width: '64px', height: '64px', zIndex: 1055 }}
                onClick={() => setShowAddModal(true)}
            >
                <i className="bi bi-plus-lg fs-3"></i>
            </button>

            {/* Modal Thêm Mới */}
            {showAddModal && (
                <>
                    <Modal
                        show={showAddModal}
                        onHide={() => setShowConfirmExit(true)}
                        size="xl"
                        centered
                        backdrop="static"
                        keyboard={false}
                        className="text-white"
                    >                             
                        <Modal.Header closeButton className="bg-dark border-bottom border-secondary" closeVariant="white">
                            <Modal.Title className="fs-4 text-info">
                                <i className="bi bi-house-add me-2"></i>
                                Thêm bất động sản mới
                            </Modal.Title>
                        </Modal.Header>      

                        <Modal.Body className="bg-dark" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                            <form onSubmit={(e) => e.preventDefault()}>         
                                <div className="row g-3">

                                    {/* 1. Số điện thoại (bắt buộc) */}
                                    <div className="col-12 col-md-6">
                                        <PhoneTagInput
                                            value={formData.phone}
                                            onChange={(phones) => setFormData(prev => ({ ...prev, phone: phones }))}
                                            // onDuplicateFound={(duplicatePhone) => {
                                            //     setPhoneToCheck(duplicatePhone);
                                            //     setShowPhoneExistsModal(true);
                                            // }}
                                        />
                                    </div>

                                    {/* 2. Tên chủ nhà */}
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Tên chủ nhà</label>
                                        <input
                                            type="text"
                                            name="ownerName"
                                            className="form-control"
                                            value={formData.ownerName}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    {/* 3. Loại chủ */}
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Loại chủ</label>
                                        <select
                                            name="ownerType"
                                            className="form-select"
                                            value={formData.ownerType}
                                            onChange={handleInputChange}
                                        >
                                            <option>Chủ nhà</option>
                                            <option>Đầu tư</option>
                                            <option>Môi giới</option>
                                        </select>
                                    </div>

                                    {/* 4. Số nhà */}
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Số nhà</label>
                                        <input
                                            type="text"
                                            name="houseNumber"
                                            className="form-control"
                                            value={formData.houseNumber}
                                            onChange={handleInputChange}
                                            placeholder="Ví dụ: 123, 45A, 67/89..."
                                        />
                                    </div>

                                    {/* 5. Tên đường (bắt buộc) */}
                                    <div className="col-12">
                                        <label className="form-label">
                                            Tên đường <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="street"
                                            className="form-control"
                                            value={formData.street}
                                            onChange={handleInputChange}
                                            placeholder="Ví dụ: Nguyễn Văn Cừ, Lê Văn Sỹ..."
                                            required
                                        />
                                    </div>

                                    {/* 6. Quận cũ (bắt buộc) */}
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">
                                            Quận/huyện cũ <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            name="oldDistrict"
                                            className="form-select"
                                            value={formData.oldDistrict}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="">Chọn quận/huyện</option>
                                            {Object.keys(districtsData).map(d => (
                                                <option key={d} value={d}>{d}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* 7. Phường cũ */}
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">Phường cũ</label>
                                        <select
                                            name="oldWard"
                                            className="form-select"
                                            value={formData.oldWard}
                                            onChange={handleInputChange}
                                            disabled={!formData.oldDistrict}
                                        >
                                            <option value="">Chọn phường cũ</option>
                                            {selectedOldWards.map((ward, i) => (
                                                <option key={i} value={ward}>{ward}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* 8. Phường mới */}
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">Phường mới</label>
                                        <select
                                            name="newWard"
                                            className="form-select"
                                            value={formData.newWard}
                                            onChange={handleInputChange}
                                            disabled={!formData.oldDistrict}
                                        >
                                            <option value="">Chọn phường mới</option>
                                            {selectedNewWards.map((ward, i) => (
                                                <option key={i} value={ward}>{ward}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* 9. Loại nhà */}
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Loại nhà</label>
                                        <select
                                            name="propertyType"
                                            className="form-select"
                                            value={formData.propertyType}
                                            onChange={handleInputChange}
                                        >
                                            <option>Nhà phố</option>
                                            <option>Biệt thự</option>
                                            <option>Toà nhà văn phòng</option>
                                            <option>Đất trống</option>
                                            <option>Kho xưởng</option>
                                        </select>
                                    </div>

                                    {/* 10. Vị trí */}
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Vị trí</label>
                                        <select
                                            name="position"
                                            className="form-select"
                                            value={formData.position}
                                            onChange={handleInputChange}
                                        >
                                            <option>Mặt tiền</option>
                                            <option>Mặt tiền hẻm</option>
                                            <option>2 mặt tiền</option>
                                            <option>3 mặt tiền</option>
                                        </select>
                                    </div>

                                    {/* 11-16. Các trường số */}
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">Bề ngang (m)</label>
                                        <input type="number" name="width" className="form-control" value={formData.width} onChange={handleInputChange} placeholder="Ví dụ: 5" />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">Chiều dài (m)</label>
                                        <input type="number" name="length" className="form-control" value={formData.length} onChange={handleInputChange} placeholder="Ví dụ: 20" />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">Diện tích sàn (m²)</label>
                                        <input type="number" name="floorArea" className="form-control" value={formData.floorArea} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">Tổng diện tích sàn (m²)</label>
                                        <input type="number" name="totalArea" className="form-control" value={formData.totalArea} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">Số tầng</label>
                                        <input type="number" name="floors" className="form-control" value={formData.floors} onChange={handleInputChange} min="1" />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">Giá thuê (VNĐ)</label>
                                        <input type="number" name="price" className="form-control" value={formData.price} onChange={handleInputChange} placeholder="Triệu/tháng" />
                                    </div>

                                    {/* 17. Mô tả */}
                                    <div className="col-12">
                                        <label className="form-label">Mô tả</label>
                                        <textarea
                                            name="description"
                                            className="form-control"
                                            rows="5"
                                            value={formData.description}
                                            onChange={handleInputChange}
                                            placeholder="Nhà mới đẹp, hướng Đông, hẻm xe hơi, gần trường học..."
                                        ></textarea>
                                    </div>

                                    {/* 18. Hình ảnh */}
                                    <div className="col-12">
                                        <label className="form-label">Hình ảnh</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            multiple
                                            accept="image/*"
                                            onChange={handleImageChange}
                                        />
                                        <div className="border p-3 bg-secondary bg-opacity-10 rounded text-center">
                                            <p className="text-info small mb-3">
                                                (Copy ảnh trước → bấm nút hoặc CTRL+V → tự động dán)
                                            </p>

                                            <div className="d-flex flex-column gap-3 align-items-center">
                                                {/* Nút chính – siêu thông minh */}
                                                <button
                                                    type="button"
                                                    className="btn btn-primary  shadow-sm"
                                                    onClick={handleSmartPaste}
                                                    style={{ fontSize: '1.1rem' }}
                                                >
                                                    <i className="bi bi-clipboard2-plus-fill me-2 fs-4"></i>
                                                    Dán ảnh ngay
                                                </button>

                                                {/* Input ẩn để bắt paste thủ công */}
                                                <input
                                                    ref={hiddenPasteInput}
                                                    type="text"
                                                    readOnly
                                                    style={{ position: 'absolute', left: '-9999px' }}
                                                    onPaste={handlePasteImage}
                                                />

                                                {/* Input mở thư viện ảnh khi không dán được */}
                                                <input
                                                    ref={fileInputMobileRef}
                                                    type="file"
                                                    accept="image/*"
                                                    multiple
                                                    className="d-none"
                                                    onChange={handleImageChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="mt-3 row g-3">
                                            {formData.images.map((img, i) => (
                                                <div key={i} className="col-6 col-md-4 col-lg-3 position-relative">
                                                    <img
                                                        src={URL.createObjectURL(img)}
                                                        alt={`Hình ${i + 1}`}
                                                        className="img-fluid rounded shadow-sm"
                                                        style={{ height: '140px', objectFit: 'cover' }}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm rounded-circle position-absolute top-0 end-0 m-2"
                                                        onClick={() => removeImage(i)}
                                                        style={{ width: '32px', height: '32px' }}
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* 19. Trạng thái */}
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Trạng thái</label>
                                        <select
                                            name="status"
                                            className="form-select"
                                            value={formData.status}
                                            onChange={handleInputChange}
                                        >
                                            <option>Đang cho thuê</option>
                                            <option>Đã cho thuê</option>
                                            <option>Đã bán</option>
                                        </select>
                                    </div>

                                    {/* Thông tin hệ thống */}
                                    <div className="col-12 border-top pt-4 mt-4">
                                        <div className="row text-info">
                                            <div className="col-12 col-md-6">
                                                <small><strong>Người tạo:</strong> {username || 'N/A'}</small><br/>
                                                <small><strong>Ngày tạo:</strong> {new Date().toLocaleString('vi-VN')}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </Modal.Body>
                        <Modal.Footer className="bg-dark border-0">
                            <button 
                                type="button" 
                                className="btn btn-outline-secondary px-4" 
                                onClick={() => setShowConfirmExit(true)}
                                disabled={isSubmitting}
                            >
                                Hủy
                            </button>
                            <button 
                                type="button" 
                                className="btn btn-success px-5 d-flex align-items-center gap-2"
                                onClick={handleSubmit}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status"></span>
                                        Đang thêm...
                                    </>
                                ) : (
                                    'Thêm mới'
                                )}
                            </button>

                        </Modal.Footer>
                    </Modal>
                    {/* Modal xác nhận thoát */}
                    {showConfirmExit && (
                        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 1060 }}>
                            <div className="modal-dialog modal-dialog-centered modal-sm">
                                <div className="modal-content bg-dark text-white">
                                    <div className="modal-body text-center py-4">
                                        <i className="bi bi-exclamation-triangle text-warning fs-1"></i>
                                        <h5 className="mt-3">Thoát mà không lưu?</h5>
                                        <p>Dữ liệu bạn vừa nhập sẽ bị mất.</p>
                                    </div>
                                    <div className="modal-footer justify-content-center border-0">
                                        <button className="btn btn-secondary" onClick={() => setShowConfirmExit(false)}>Quay lại</button>
                                        <button className="btn btn-danger" onClick={() => { setShowAddModal(false); setShowConfirmExit(false); resetForm(); }}>Thoát</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* === LOADING OVERLAY KHI ĐANG THÊM MỚI === */}
                    {isSubmitting && (
                        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-black bg-opacity-50" style={{ zIndex: 9999 }}>
                            <div className="bg-dark p-5 rounded-4 text-center shadow">
                                <div className="spinner-border text-warning" style={{ width: '4rem', height: '4rem' }}></div>
                                <h4 className="mt-4 text-white">Đang thêm bất động sản...</h4>
                            </div>
                        </div>
                    )}

                    {/* Modal SĐT đã tồn tại */}
                    {showPhoneExistsModal && (
                        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 1060 }}>
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content bg-dark text-white">
                                    <div className="modal-body text-center">
                                        <i className="bi bi-exclamation-triangle text-warning fs-1"></i>
                                        <h5 className="mt-3">Số điện thoại đã tồn tại!</h5>
                                        <p>Số <strong>{phoneToCheck}</strong> đã được dùng cho bất động sản khác, bạn muốn:</p>
                                    </div>
                                    <div className="modal-footer border-0 justify-content-center gap-3">
                                        <button className="btn btn-light px-4" onClick={handleForceSubmit}>
                                            Vẫn thêm mới
                                        </button>
                                        <button className="btn btn-warning px-4" onClick={() => handlePhoneExistAction('view')}>
                                            Xem tin cũ
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default Welcome